/**
 * Move one visible row onto another visible row, inside the full list.
 *
 * Rows left out of `visibleIds` stay beside the rows that did not move.
 * Dropping a row on itself, or naming a row that is not visible, returns
 * the same array.
 */
export function reorderVisibleInFullList<T extends { id: string }>(
  items: T[],
  visibleIds: readonly string[],
  activeId: string,
  overId: string,
): T[] {
  if (activeId === overId) return items;
  const from = visibleIds.indexOf(activeId);
  const to = visibleIds.indexOf(overId);
  if (from === -1 || to === -1) return items;

  const nextVisible = visibleIds.slice();
  const [movedId] = nextVisible.splice(from, 1);
  nextVisible.splice(to, 0, movedId);

  const moved = items.find((item) => item.id === movedId);
  if (!moved) return items;

  const successorId = nextVisible[nextVisible.indexOf(movedId) + 1];
  const rest = items.filter((item) => item.id !== movedId);
  const insertAt =
    successorId === undefined
      ? rest.length
      : rest.findIndex((item) => item.id === successorId);
  if (insertAt === -1) return items;

  const next = rest.slice();
  next.splice(insertAt, 0, moved);
  return next;
}
